export const fwkEvent = {
    onAdjustInit: "onAdjustInit",
    onAdjustSuccess: "onAdjustSuccess",
}